import "./NavBar.scss";

const NavBar = () => {
  return (
    <div className="navbar-container">
      <h1 className="navbar-header">Shopping List</h1>
    </div>
  );
};

export default NavBar;
